import {Component} from "react";


class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        // Zaktualizuj stan, aby następny render pokazał zastępcze UI.
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // Możesz także zalogować błąd do zewnętrznego serwisu raportowania błędów
        // logErrorToMyService(error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            // Możesz wyrenderować dowolny interfejs zastępczy.
            return <div className="d-flex justify-content-center align-items-center py-4">Przepraszamy, napotkano problem</div>;
        }

        return this.props.children;
    }
}

export default ErrorBoundary;